import { ROULETTE_CHIPS_COLOR } from '../../games/roulette/rouletteCore/constants';
import { BACCARAT_CHIPS_COLOR } from '../../games/baccarat/baccaratCore/constants';

export const GameIds = {
  Plinko: 36,
  Limbo: 37,
  Crash: 38,
  BlackJack: 39,
  Hilo: 40,
  Dice: 41,
  Wheel: 42,
  Keno: 43,
  Roulette: 44,
  Baccarat: 45,
  Mines: 46,
  AlternativeDice: 47,
  CoinFlip: 48,
  Fishing: 49,
  Drift: 50,
  Football: 51,
  DoubleDice: 102,
  FastTrade: 104,
  Limbo10: 106,
  HandBlackJack: 108,
  Tower: 109,
  PowerOfGods: 208,
};

export const AllGamesConfigurations = {
  [GameIds.Plinko]: {
    isShowTurboIcon: true,
    isShowHotKeys: true,
  },
  [GameIds.Limbo]: {
    isShowTurboIcon: true,
    isShowMusicIcon: true,
    isShowHotKeys: true,
  },
  [GameIds.Crash]: {
    isRoundGame: true,
    isShowHotKeys: true,
  },
  [GameIds.BlackJack]: {
    isShowTurboIcon: true,
    isShowMusicIcon: true,
    isCardsGame: true,
    isShowHotKeys: true,
  },
  [GameIds.Hilo]: {
    isShowTurboIcon: true,
    isShowMusicIcon: true,
    isCardsGame: true,
    isShowHotKeys: true,
  },
  [GameIds.Dice]: {
    isShowTurboIcon: true,
    isShowHotKeys: true,
  },
  [GameIds.Wheel]: {
    isShowTurboIcon: true,
    isShowHotKeys: true,
  },
  [GameIds.Keno]: {
    isShowTurboIcon: true,
    isShowHotKeys: true,
  },
  [GameIds.Roulette]: {
    isGameInChips: true,
    isShowMusicIcon: true,
    isShowTurboIcon: true,
    chipColors: ROULETTE_CHIPS_COLOR,
    isShowHotKeys: true,
  },
  [GameIds.Baccarat]: {
    isCardsGame: true,
    isGameInChips: true,
    isShowTurboIcon: true,
    isShowMusicIcon: true,
    chipColors: BACCARAT_CHIPS_COLOR,
    isShowHotKeys: true,
  },
  [GameIds.Mines]: {
    isShowMusicIcon: true,
    isShowTurboIcon: true,
    isShowHotKeys: true,
  },
  [GameIds.AlternativeDice]: {
    isShowTurboIcon: true,
    isShowHotKeys: true,
  },
  [GameIds.CoinFlip]: {
    isShowTurboIcon: true,
    isShowMusicIcon: true,
    isShowHotKeys: true,
  },
  [GameIds.Fishing]: {
    isWithReconnect: false,
    isShowMusicIcon: true,
    isRoundGame: true,
    isShowHotKeys: true,
  },
  [GameIds.Drift]: {
    isShowMusicIcon: true,
    isShowHotKeys: true,
  },
  [GameIds.Football]: {
    isShowMusicIcon: true,
    isShowHotKeys: true,
  },
  [GameIds.DoubleDice]: {
    isShowTurboIcon: true,
    isShowHotKeys: true,
  },
  [GameIds.FastTrade]: {
    isShowMusicIcon: true,
    isShowTurboIcon: false,
    isRoundGame: true,
    isShowHotKeys: false,
  },
  [GameIds.Limbo10]: {
    isShowTurboIcon: true,
    isShowMusicIcon: true,
    isShowHotKeys: true,
  },
  [GameIds.HandBlackJack]: {
    isShowTurboIcon: true,
    isShowMusicIcon: true,
    isShowHotKeys: true,
    isGameInChips: true,
    chipColors: ROULETTE_CHIPS_COLOR,
    isCardsGame: true,
  },
  [GameIds.Tower]: {
    isShowTurboIcon: false,
    isShowMusicIcon: true,
    isShowHotKeys: true,
  },
  [GameIds.PowerOfGods]: {
    isShowTurboIcon: true,
    isShowMusicIcon: true,
    isShowHotKeys: true,
    isSpecialSpinInfo: true,
  },
};

export const ROUND_GAMES_GAME_IDS = [
  GameIds.Crash,
  GameIds.Fishing,
  GameIds.FastTrade,
  GameIds.PowerOfGods,
];
